module.exports = __webpack_public_path__ + "static/media/galerija_2019 (26).6b8bc3e9.jpg";